export default __webpack_public_path__ + "static/media/placeholder_image_landscape.47e78288.png";